import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Navbar } from '../components/common/Navbar';
import { Footer } from '../components/common/Footer';
import { Button } from '../components/common/Button';
import { Badge } from '../components/common/Badge';
import { SEO } from '../components/common/SEO';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-navy">
      <SEO title="お探しのページが見つかりませんでした (404)" noindex={true} />
      <Navbar />
      <main className="flex-1 flex items-center justify-center py-20 px-4">
        <div className="max-w-lg text-center space-y-5">
          <Badge variant="cyan">404 NOT FOUND</Badge>
          <h1 className="text-3xl sm:text-4xl font-bold text-navy">
            お探しのページが見つかりませんでした
          </h1>
          <p className="text-sm sm:text-base text-navy-muted leading-relaxed">
            アクセスいただいたURLは変更または削除された可能性があります。トップページまたは上部メニューより目的のページをお探しください。
          </p>
          <div className="pt-2">
            <Button to="/" variant="primary" icon={<ArrowRight className="w-4 h-4" />}>
              トップページへ戻る
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
